<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <form>
      <div class="inner">
        <add-button
            v-if="$_createActionAllowed"
            :title="'Přidat tématickou skupinu' | translate"
            route-name="thematicGroupNew"
        ></add-button>
        <h1 v-translate>Tématické skupiny kanálů</h1>
      </div>
      <div class="inner_white">
        <div class="filter">
          <div class="field_left">
            <search-input input-class="search" v-model="formFields.search"></search-input>
          </div>
          <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
        </div>
        <form>
          <div class="table_overflow">
            <table class="vypis" ref="table_with_action_line" v-show="dataLoaded">
            <thead>
            <tr>
              <th class="no_padding drag_drop"></th>
              <th class="no_padding checkbox"></th>
              <sorting-table-title
                  v-for="title in sortingTableTitles"
                  :key="title.key"
                  :column="title.column"
                  :sort="getActiveSort(title.column)"
                  :extraStyle="title.style"
                  @changeSorting="changeSorting"
              >{{ title.name }}
              </sorting-table-title>
              <th class="no_padding edit"></th>
            </tr>
            </thead>
            <thematic-group-row v-for="entity in entities"
                         :entity="entity"
                         :key="entity.id"
                         :selectedEntities="selectedEntities"
                         :all-channels="allChannels"
                         ref="thematic_group_row"
                         @input="select"
                         @deleteThematicGroup="deleteEntity"
            ></thematic-group-row>
          </table>
          </div>
          <list-action-line
              :entities="entities"
              :selected-entities="selectedEntities"
              :multiple-action-options="multipleActionOptions"
              :offset="formFields.offset"
              :limit="formFields.limit"
              :total-count="totalCount"
              @select-all="toggleSelectAll"
              @run-multiple-action="runMultipleAction"
              @limit="setLimit"
              @offset="setOffset"
              ref="action_line"
          ></list-action-line>
        </form>
      </div>
    </form>
  </div>
</template>

<script>
import listActions from "../../mixins/list-actions";
import ThematicGroupRow from "./ThematicGroupRow.vue";

export default {
  name: "ThematicGroupList",
  components: {
    ThematicGroupRow
  },
  mixins: [listActions],
  data(){
    return {
      moduleName: 'thematic_groups',
      allChannels: [],
    }
  },
  created(ThematicGroupService)
  {
    this.entityService = ThematicGroupService;
    this.createdInit();
  },
  computed: {
    sortingTableTitles() {
      return [
        {key: 1, name: this.$gettext('Název'), column: 'sName', style: {minWidth: '100px'}},
        {key: 2, name: this.$gettext('Operátor'), column: 'sOperatorName'},
        {key: 3, name: this.$gettext('Dostupné na zařízení'), column: 'sDeviceVisibility'},
        {key: 4, name: this.$gettext('Systémová skupina'), column: 'sCustomGroup'},
        {key: 5, name: this.$gettext('Počet kanálů'), column: 'sChannelsCount'},
        {key: 6, name: this.$gettext('Vytvořeno'), column: 'sDateCreated'},
        {key: 7, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
      ]
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')}
      ]
    },
    csvHeaders(){
      return this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles);
    },
  },
  methods: {
    _afterGetEntitiesActions(data){
      this.allChannels = data['all_channels'];
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/thematicGroups/ThematicGroupList.vue